import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="h-full flex flex-col items-center justify-center space-y-6">
      <h1 className="text-2xl font-bold text-center">404 – {t('notFound.title', 'Page Not Found')}</h1>
      <p className="text-gray-400 text-center text-sm">
        {t('notFound.message', "Sorry, the page you are looking for doesn't exist or has been moved.")}
      </p>
      <a
        href="/"
        className="w-full max-w-xs cursor-pointer text-sm flex justify-center items-center space-x-2 bg-[#FC4C02] hover:bg-[#e04402] text-white py-2 rounded-sm"
      >
        <span>{t('notFound.backHome', 'Back to Home')}</span>
      </a>
    </div>
  );
};

export default NotFound;
